export default __webpack_public_path__ + "static/media/img (2).8f8744b7.jpg";